import Vue from 'vue'
import VueRouter from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { routers, ROUTER_LOGIN_SSO, ROUTER_LOGIN, ROUTER_NAME_HOME, ROUTER_NAME_404, ROUTER_NAME_403 } from  './router'
import { VUE_ROUTER_MODE } from "../../config/myConfig";
import BrowserUtils from "../libs/utils/BrowserUtils";
import RouterUtils from "../libs/utils/RouterUtils";
import {MSG_MODES, MSG_TYPES, setMessage} from "../libs/message";
import UserPersistence from "../persistence/UserPersistence";
import {ExitOut} from "../libs/comFun/exitOut";
import ArrayUtils from "../libs/utils/ArrayUtils";

/**
 * 重写路由的push方法
 * 为了解决这个报错Navigating to current location (XXX) is not allowed
 * 出现错误原因是已经在某个路由上了，再次通过push方法进入此路由
 */
const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return routerPush.call(this, location, onResolve, onReject);
  return routerPush.call(this, location).catch(error=> error)
};
Vue.use(VueRouter)
// 路由配置
const RouterConfig = {
  mode: VUE_ROUTER_MODE,
  routes: routers
};
const defaultMenuList = [
  {routeUrl: ROUTER_NAME_404},
  {routeUrl: ROUTER_NAME_HOME},
  {routeUrl: ROUTER_NAME_403},
  {routeUrl: ROUTER_LOGIN_SSO},
  {routeUrl: ROUTER_LOGIN},
];



export const router = new VueRouter(RouterConfig)

router.beforeEach((to, from, next) => {

  if(process.env.NODE_ENV !== 'development') {
    var versionScript = document.createElement("script");
    versionScript.src =  location.origin+ '/chen.js?v=' + new Date().getTime();
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(versionScript, s);

    window.getVersion = version => {
      if(localStorage.frontendVersion && version !== localStorage.frontendVersion) {
        setMessage({
          type: MSG_TYPES.WARNING,
          mode: MSG_MODES.MESSAGE_BOX,
          message: '系统已更新！请刷新后重试',
          title: "提示",
          onOk: () => window.location.reload(true),
          showCancelButton: false,
          closeOnClickModal: false,
          showClose: false,
        });
        localStorage.frontendVersion = version; // 保存 以便下次使用判断
        return
      }

      localStorage.frontendVersion = version; // 保存 以便下次使用判断
    };
  }

 



  // if (!UserPersistence.getToken() && ArrayUtils.getItemIndex(defaultMenuList, 'routeUrl', to.name) === -1) { // 当前没有登录，且前往的页面不是白名单页面
  //   ExitOut();
  //   if (process.env.NODE_ENV === 'development') { // 本地环境忽略
  //     setMessage({
  //       type: MSG_TYPES.WARNING,
  //       message: '无token，请先设置token!'
  //     });
  //     next();
  //   }
  // } if (UserPersistence.getToken() && (to.name === ROUTER_LOGIN_SSO)) { // 当前已经登录，且前往的是SSO页面
  //   if(menu.length > 0) {
  //     next({
  //       name: menu[0].routeUrl,
  //     });
  //   } else {
  //     ExitOut();
  //     if (process.env.NODE_ENV === 'development') { // 本地环境忽略
  //       setMessage({
  //         type: MSG_TYPES.WARNING,
  //         message: '无菜单，请重新登录!'
  //       });
  //       next();
  //     }
  //   }
  // } else {
  //   const curRouterObj = RouterUtils.getRouterObjByName(menuList, to.name);
  //   if(!curRouterObj) { // 如果这个路由没有找到，或者没权限
  //     setMessage({
  //       type:MSG_TYPES.WARNING,
  //       message: '没有对应菜单权限!'
  //     });
  //     NProgress.done();
  //     next({
  //       replace: true,
  //       name: ROUTER_NAME_404
  //     });
  //   } else{ // 有权限
  //     next();
  //   }
  // }
  next();
});

router.afterEach((to) => {
  NProgress.done();
  // Util.openNewPage(router.app, to.name, to.params, to.query);
  window.scrollTo(0, 0);
});



// WEBPACK FOOTER //
// ./src/router/index.js